/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailAttachment } from './emailAttachment';
import { UserDetailDto } from './userDetailDto';


export interface EmailDetailDto { 
    id: string;
    user?: UserDetailDto;
    subject: string;
    htmlBody: string;
    emailType: EmailDetailDto.EmailTypeEnum;
    attachments: Array<EmailAttachment>;
    recipients: Array<string>;
    cc?: Array<string>;
    isSent: boolean;
}
export namespace EmailDetailDto {
    export type EmailTypeEnum = 'INSPECTION' | 'REPAIR_TASK' | 'MAINTENANCE_TIMER';
    export const EmailTypeEnum = {
        Inspection: 'INSPECTION' as EmailTypeEnum,
        RepairTask: 'REPAIR_TASK' as EmailTypeEnum,
        MaintenanceTimer: 'MAINTENANCE_TIMER' as EmailTypeEnum
    };
}


